import { cateringOrderClient } from '@/services/clients'

export default {
  getPromotions() {
    return cateringOrderClient.get('/promotions', undefined, {
      callerHandlesCriticalError: true,
    })
  },
}
